document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.huca-card-carousel').forEach((carousel) => {

    const track = carousel.querySelector('.huca-card-carousel__track');
    const slides = carousel.querySelectorAll('.huca-card-carousel__slide');
    const dots = carousel.querySelectorAll('.huca-card-carousel__dot');
    const thumbnails = carousel.querySelectorAll('.huca-card-carousel__thumbnail');

    if (!track || slides.length <= 1) return;

    let currentIndex = Array.from(slides).findIndex((slide) =>
      slide.classList.contains('is-active')
    );

    if (currentIndex < 0) currentIndex = 0;

    function showSlide(index) {

      if (index < 0 || index >= slides.length) return;

      currentIndex = index;

      track.style.transform = `translateX(-${index * 100}%)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });

    }
/* =================================================
   SWIPE MÓVIL
   ================================================= */

let touchStartX = 0;
let touchStartY = 0;
let touchCurrentX = 0;
let isHorizontalSwipe = false;
let isDragging = false;

carousel.style.touchAction = 'pan-y';

carousel.addEventListener('touchstart', (event) => {

  if (event.touches.length !== 1) return;

  touchStartX = event.touches[0].clientX;
  touchStartY = event.touches[0].clientY;
  touchCurrentX = touchStartX;

  isHorizontalSwipe = false;
  isDragging = false;

  track.style.transition = 'none';

}, { passive: true });


carousel.addEventListener('touchmove', (event) => {

  if (event.touches.length !== 1) return;

  touchCurrentX = event.touches[0].clientX;

  const deltaX =
    touchCurrentX - touchStartX;

  const deltaY =
    event.touches[0].clientY - touchStartY;

  if (
    Math.abs(deltaX) > 10 &&
    Math.abs(deltaX) > Math.abs(deltaY)
  ) {

    isHorizontalSwipe = true;
    isDragging = true;

    event.preventDefault();

    const width =
      carousel.clientWidth;

    const baseOffset =
      -(currentIndex * width);

    const minOffset =
      -((slides.length - 1) * width);

    let newOffset =
      baseOffset + deltaX;

    if (newOffset > 0) {
      newOffset = 0;
    }

    if (newOffset < minOffset) {
      newOffset = minOffset;
    }

    track.style.transform =
      `translate3d(${newOffset}px, 0, 0)`;

  }

}, { passive: false });


carousel.addEventListener('touchend', (event) => {

  if (!isHorizontalSwipe) {
    track.style.transition = 'transform 0.35s ease';
    showSlide(currentIndex);
    return;
  }

  event.preventDefault();

  const deltaX =
    touchCurrentX - touchStartX;

  const threshold = 45;

  if (deltaX < -threshold) {

    showSlide(currentIndex + 1);

  } else if (deltaX > threshold) {

    showSlide(currentIndex - 1);

  } else {

    showSlide(currentIndex);

  }

  isHorizontalSwipe = false;
  isDragging = false;

}, { passive: false });

    /* Posición inicial */

    showSlide(currentIndex);

    /* Miniaturas */

    thumbnails.forEach((thumb, index) => {

      thumb.addEventListener('click', (event) => {

        event.preventDefault();
        event.stopPropagation();

        showSlide(index);

      });

    });

    /* Puntos */

    dots.forEach((dot, index) => {

      dot.addEventListener('click', (event) => {

        event.preventDefault();
        event.stopPropagation();

        showSlide(index);

      });

    });

  });

});